angular.module('dictionary')
    .component('dictionaryPickerMultiple', {
        require: {
            ngModelCtrl: 'ngModel'
        },
        bindings: {
            ngModel: '=',
            type: "=",
            modelType: '<',
            required: "=",
            onChange: "&",
            filterField: "=?",
            disableList: "=?",
            disableAdd: "=?",
            placeholderKey: "@"
        },
        templateUrl: "app/dictionary/picker-multiple.html",
        controllerAs: 'ctrl',
        controller: function (uiSelectFix, Dictionary, DictionaryService) {
            const ctrl = this;
            ctrl.uiSelectFix = uiSelectFix;

            ctrl.$onInit = () => {
                ctrl.placeholderKey = ctrl.placeholderKey || "select.choose"
                ctrl.filterStyle = ctrl.filterField || false;
                ctrl.modelType = ctrl.modelType || "object";
                ctrl.disableList = ctrl.disableList || false;
                ctrl.disableAdd = ctrl.disableAdd || false;
                ctrl.items = [];

                ctrl.ngModelCtrl.$render = () => {
                    ctrl.selected = mapToSelected(ctrl.ngModelCtrl.$viewValue);
                };
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => mapToModel(viewValue));

                ctrl.loadItems();
            };

            ctrl.add = () => DictionaryService.addModal(ctrl.type).then(() => ctrl.loadItems());
            ctrl.list = () => DictionaryService.list(ctrl.type).then(() => ctrl.loadItems());
            ctrl.loadItems = () => Dictionary.list({type: ctrl.type}).$promise.then(items => {
                ctrl.items = formatItems(items);
                ctrl.selected = mapToSelected(ctrl.ngModelCtrl.$viewValue);
            });

            ctrl.$onChanges = changes => {
                if (changes.ngModel && ctrl.ngModelCtrl) {
                    ctrl.selected = mapToSelected(changes.ngModel.currentValue);
                }
            };

            ctrl.onSelectionChanged = ($item, $model) => {
                ctrl.ngModelCtrl.$setViewValue(ctrl.selected || []);
                ctrl.ngModelCtrl.$validate();
                ctrl.ngModelCtrl.$render();

                if (angular.isFunction(ctrl.onChange)) {
                    ctrl.onChange({$item: $item, $model: $model});
                }
            };

            function formatItems(items) {
                if (!angular.isArray(items)) {
                    return [];
                }

                return items
                    .map(item => ({id: item.id, name: item.name}))
                    .sort((a, b) => a.name > b.name ? 1 : -1)
            }

            function mapToSelected(items) {
                if (!angular.isArray(items)) {
                    return [];
                }

                return items
                    .map(item => normalizeItem(item))
                    .filter(item => item != null)
                    .sort((a, b) => a.name > b.name ? 1 : -1)
            }

            function mapToModel(items) {
                if (!angular.isArray(items)) {
                    return [];
                }

                if (ctrl.modelType === "id") {
                    return items.map(item => item.id);
                }

                return items.map(item => ({id: item.id, name: item.name}));
            }

            function normalizeItem(item) {
                if (item == null) {
                    return null;
                }

                if (angular.isObject(item)) {
                    if (item.id == null) {
                        return null;
                    }

                    if (item.name != null) {
                        return {id: item.id, name: item.name};
                    }

                    return findById(item.id);
                }

                return findById(item);
            }

            function findById(id) {
                return ctrl.items.find(item => String(item.id) === String(id)) || null;
            }
        },
    });
